module.exports = __webpack_public_path__ + "static/media/img1.0aa9e68d.jpg";